export const premiacaoConsolidadoPeriodFilterKeys = ['mesFechamento', 'anoFechamento'];

export const premiacaoConsolidadoMultiSelectFilterKeys = [
  'nomeTabelaPremiacao',
  'segmentoTabelaPremiacao'
];

export const premiacaoConsolidadoFilterConfig = [
  {
    id: 'mesFechamento',
    type: 'number',
    label: 'Mês Fechamento',
    placeholder: '1 a 12',
    required: true
  },
  {
    id: 'anoFechamento',
    type: 'number',
    label: 'Ano Fechamento',
    placeholder: 'Ex: 2026',
    required: true
  },
  {
    id: 'frotaCavalo',
    type: 'text',
    label: 'Frota Cavalo',
    placeholder: 'Filtrar por frota'
  },
  {
    id: 'cpfMotorista',
    type: 'text',
    label: 'CPF Motorista',
    placeholder: 'Filtrar por CPF'
  },
  {
    id: 'motorista',
    type: 'text',
    label: 'Motorista',
    placeholder: 'Filtrar por nome'
  },
  {
    id: 'nomeTabelaPremiacao',
    type: 'searchSelect',
    label: 'Tabela Premiação',
    placeholder: 'Selecione uma ou mais tabelas',
    isMulti: true,
    showSelectAll: true,
    options: []
  },
  {
    id: 'segmentoTabelaPremiacao',
    type: 'searchSelect',
    label: 'Segmento',
    placeholder: 'Selecione um ou mais segmentos',
    isMulti: true,
    showSelectAll: true,
    options: []
  },
  {
    id: 'valorPremiacao',
    type: 'text',
    label: 'Valor Premiação',
    placeholder: 'Filtrar por valor'
  }
];

export const premiacaoConsolidadoColumnFilterKeys = [
  'frotaCavalo',
  'cpfMotorista',
  'motorista',
  'nomeTabelaPremiacao',
  'segmentoTabelaPremiacao',
  'valorPremiacao'
];
